import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component } from 'vue-property-decorator';
import AbpBase from '@/lib/AbpBase';
import { FieldType, CompareType } from '@/store/entities/filter';
import { GetRolesInput } from '@/lib/service-proxy/service-proxies';
import CreateOrUpdateRole, { PermissionDto } from './CreateOrUpdateRole';
import arrayToTree from 'array-to-tree';
import Template from './Roles.html';
import RoleViewModal from './RoleViewModal';
var Roles = /** @class */ (function (_super) {
    __extends(Roles, _super);
    function Roles() {
        var _this = _super.call(this) || this;
        _this.filters = [
            { Type: FieldType.String, Value: '', FieldName: 'Name', CompareType: CompareType.Contains },
            { Type: FieldType.String, Value: '', FieldName: 'DisplayName', CompareType: CompareType.Contains },
            { Type: FieldType.DataRange, Value: '', FieldName: 'Description', CompareType: CompareType.Contains },
            { Type: FieldType.String, Value: '', FieldName: 'Permission', CompareType: CompareType.Equal }
        ];
        _this.createModalShow = false;
        _this.selectedPermissions = '';
        return _this;
    }
    Object.defineProperty(Roles.prototype, "viewModal", {
        get: function () {
            return this.$refs.viewModal;
        },
        enumerable: true,
        configurable: true
    });
    Roles.prototype.edit = function () {
        this.createModalShow = true;
    };
    Object.defineProperty(Roles.prototype, "list", {
        get: function () {
            return this.$store.state.role.list;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Roles.prototype, "loading", {
        get: function () {
            return this.$store.state.role.loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Roles.prototype, "scopePermissions", {
        get: function () {
            return this.$store.state.role.permissions.map(function (permission) {
                var treeDto = new PermissionDto(permission);
                treeDto.title = permission.displayName;
                treeDto.expand = treeDto.name.split('.').length < 2;
                return treeDto;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Roles.prototype, "permissions", {
        get: function () {
            var treeData = arrayToTree(this.scopePermissions, {
                parentProperty: 'parentName',
                customID: 'name'
            });
            treeData.forEach(function (data) {
                if (data.checked && data.children.length > 0) {
                    data.checked = false;
                }
            });
            return treeData;
        },
        enumerable: true,
        configurable: true
    });
    Roles.prototype.create = function () {
        this.$store.commit('role/edit', {});
        this.createModalShow = true;
    };
    Roles.prototype.mounted = function () {
        this.$store.commit('role/initAllPermissions', {});
    };
    Roles.prototype.pageChange = function (page) {
        this.$store.commit('role/setCurrentPage', page);
        this.getpage();
    };
    Roles.prototype.pagesizeChange = function (pagesize) {
        this.$store.commit('role/setPageSize', pagesize);
        this.getpage();
    };
    Roles.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.pageChange(1);
                return [2 /*return*/];
            });
        });
    };
    Roles.prototype.getpage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestDto;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestDto = new GetRolesInput();
                        requestDto.maxResultCount = this.pageSize;
                        requestDto.skipCount = (this.currentPage - 1) * this.pageSize;
                        requestDto.name = this.filters[0].Value;
                        requestDto.displayName = this.filters[1].Value;
                        requestDto.describtion = this.filters[2].Value;
                        requestDto.permission = this.filters[3].Value;
                        return [4 /*yield*/, this.$store.dispatch({
                                type: 'role/getAll',
                                data: requestDto
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Roles.prototype, "pageSize", {
        get: function () {
            return this.$store.state.role.pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Roles.prototype, "totalCount", {
        get: function () {
            return this.$store.state.role.totalCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Roles.prototype, "currentPage", {
        get: function () {
            return this.$store.state.role.currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Roles.prototype, "columns", {
        get: function () {
            var _this = this;
            var vm = this;
            return [
                {
                    title: this.L('RoleName'),
                    key: 'name'
                },
                {
                    title: this.L('DisplayName'),
                    key: 'displayName'
                },
                {
                    title: this.L('IsStatic'),
                    render: function (h, params) {
                        return h('span', params.row.isStatic ? '是' : '否');
                    }
                },
                {
                    title: this.L('Actions'),
                    key: 'Actions',
                    width: 180,
                    render: function (h, params) {
                        var actions = [];
                        if (vm.hasPermission('Pages.Administration.Roles')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'default',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: function () {
                                        vm.$store.dispatch('role/edit', params.row);
                                        vm.viewModal.open();
                                    }
                                }
                            }, _this.L('查看')));
                        }
                        if (vm.hasPermission('Pages.Administration.Roles.Edit')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'default',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: function () {
                                        vm.$store.commit('role/edit', params.row);
                                        vm.edit();
                                    }
                                }
                            }, _this.L('Edit')));
                        }
                        if (vm.hasPermission('Pages.Administration.Roles.Delete') && !params.row.isStatic) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var _this = this;
                                        return __generator(this, function (_a) {
                                            this.$Modal.confirm({
                                                title: this.L('Tips'),
                                                content: this.L('DeleteRolesConfirm'),
                                                okText: this.L('Yes'),
                                                cancelText: this.L('No'),
                                                onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, this.$store.dispatch({
                                                                    type: 'role/delete',
                                                                    data: params.row
                                                                })];
                                                            case 1:
                                                                _a.sent();
                                                                return [4 /*yield*/, this.getpage()];
                                                            case 2:
                                                                _a.sent();
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }
                                            });
                                            return [2 /*return*/];
                                        });
                                    }); }
                                }
                            }, _this.L('Delete')));
                        }
                        return h('ButtonGroup', actions);
                    }
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Roles.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getpage();
                return [2 /*return*/];
            });
        });
    };
    Roles.prototype.handlePermissionSearch = function (value) {
    };
    Roles.prototype.handlePermissionClear = function () {
        this.filters[3].Value = null;
        this.selectedPermissions = null;
        this.scopePermissions.forEach(function (item) {
            item.checked = false;
        });
    };
    Roles.prototype.handlePermissionChecked = function (checkedNodes) {
        var _this = this;
        var selectName = [];
        var nodeNames = [];
        if (checkedNodes.length) {
            var nodes_1 = this.$refs.permissionTree.getCheckedAndIndeterminateNodes();
            checkedNodes.forEach(function (item) {
                nodeNames.push(_this.getFullDisplayName(nodes_1, item));
            });
            selectName = checkedNodes.map(function (item) { return item.name; });
        }
        this.filters[3].Value = selectName.join();
        this.selectedPermissions = nodeNames.join();
    };
    Roles.prototype.getFullDisplayName = function (nodes, node) {
        var parentNode = nodes.find(function (item) { return item.name === node.parentName; });
        var parentName = null;
        if (!!parentNode) {
            parentName = this.getFullDisplayName(nodes, parentNode);
        }
        parentName = parentName ? parentName + '-' : '';
        return parentName + node.displayName;
    };
    Roles = __decorate([
        Template,
        Component({
            components: { CreateOrUpdateRole: CreateOrUpdateRole, RoleViewModal: RoleViewModal }
        })
    ], Roles);
    return Roles;
}(AbpBase));
export default Roles;
